import { DateInput, FormDataConsumer, required } from "react-admin";

import React from "react";
import { get } from "lodash";

const ClosingDateInput = ({ visible, ...props }) => (
  <FormDataConsumer {...props}>
    {({ formData, ...rest }) => {
      const roles = get(formData, "roles", []);
      if (!visible && !roles.find((role) => role.id === 5)) {
        return null;
      }
      return <DateInput {...props} validate={required()} />;
    }}
  </FormDataConsumer>
);
export default ClosingDateInput;
